import SetCache from "./_SetCache.js";
import arraySome from "./_arraySome.js";
import cacheHas from "./_cacheHas.js";
var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
  if (arrLength != othLength && !(isPartial && othLength > arrLength))
    return !1;
  var arrStacked = stack.get(array), othStacked = stack.get(other);
  if (arrStacked && othStacked)
    return arrStacked == other && othStacked == array;
  var index = -1, result = !0, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : void 0;
  for (stack.set(array, other), stack.set(other, array); ++index < arrLength; ) {
    var arrValue = array[index], othValue = other[index];
    if (customizer)
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    if (compared !== void 0) {
      if (compared)
        continue;
      result = !1;
      break;
    }
    if (seen) {
      if (!arraySome(other, function(othValue2, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack)))
          return seen.push(othIndex);
      })) {
        result = !1;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = !1;
      break;
    }
  }
  return stack.delete(array), stack.delete(other), result;
}
export {
  equalArrays as default
};
//# sourceMappingURL=_equalArrays.js.map
